import {
  Grid,
  Typography,
  TextField,
  Button,
  Box,
  CircularProgress,
} from "@mui/material";
import { useState, useRef } from "react";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { useTheme } from "@mui/material/styles";
import { createUpload } from "../../services/ContributorArca";
import GlassCard from "../General/GlassCard";
import { useToast } from "../../context/ToastContext";

export default function ChargeFileArcaPeople() {
  const { showToast } = useToast();
  const theme = useTheme();
  const fileInputRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ people: "" });
  const [errors, setErrors] = useState({});
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const validExtensions = ["csv"];
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (!validExtensions.includes(fileExtension)) {
        setErrors({
          ...errors,
          people: "Solo se permiten archivo csv",
        });
        setSelectedFile(null);
        setForm({ ...form, people: "" });
        return;
      }
      setErrors({ ...errors, people: "" });
      setSelectedFile(file);
      setForm({ ...form, people: file.name });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();    setErrors({});
    setLoading(true);

    if (!selectedFile) {
      showToast("Debe seleccionar un archivo.", "info")
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await createUpload(formData);

      showToast(response.data.message, "success")
      setForm({ people: "" });
      setSelectedFile(null);
      setErrors({});

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } catch (error) {
      if (error.response?.status === 422 || error.response?.status === 404) {
        showToast(error.response.data?.message || "Ocurrió un error.", "error")
      } else {
        console.log(error);
        showToast("Ocurrió un error inesperado.", "error")
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid container justifyContent="center" sx={{ mt: 4 }}>
      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 10 }}>

        <GlassCard>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mb: 3,
            }}
          >
            <Box
              sx={{
                backgroundColor: theme.palette.primary.main,
                color: "white",
                borderRadius: "50%",
                width: 64,
                height: 64,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 2,
              }}
            >
              <AssignmentIcon sx={{ fontSize: 32 }} />
            </Box>

            <Typography variant="h5" align="center" fontWeight="bold">
              Carga de Base de Datos Arca
            </Typography>
            <Typography variant="body2" color="text.secondary" align="center">
              El archivo debe ser formato CSV y este proceso puede tardar horas
              lo que detiene los otros procesos del sistema hasta que este
              finalice.
            </Typography>
          </Box>

          <Box component="form" onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                <Button variant="outlined" component="label" fullWidth>
                  Seleccionar Archivo
                  <input
                    type="file"
                    hidden
                    onChange={handleFileChange}
                    ref={fileInputRef}
                  />
                </Button>
                {errors.people && (
                  <Typography color="error" variant="caption">
                    {errors.people}
                  </Typography>
                )}
              </Grid>

              {selectedFile && (
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                  <TextField
                    label="Archivo Seleccionado"
                    value={selectedFile.name}
                    InputProps={{ readOnly: true }}
                    fullWidth
                  />
                </Grid>
              )}

              <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  fullWidth
                  disabled={loading}
                 
                >
                  {loading ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    "Cargar Base de Datos Arca"
                  )}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </GlassCard>
      </Grid>

    </Grid>
  );
}
